// Reducer extracted from CoachMarksModule.js

import _ from "lodash";
import update from "immutability-helper";
import React from "react";
import { UPDATE_DATA, UPDATE_COACHMARK_STATUS } from "./CoachMarksConstants";

// Initial State
const initialState = {
  coachMarksObj: {},
  coachMarksViewStatus: { bookmarkStatus: false },
};

// Reducer Handlers
const REDUCER_HANDLERS = {
  [UPDATE_DATA]: (state, action) => {
    const params = action.payload;
    const type = _.get(params, "type", "");
    if (type) {
      if (!state.coachMarksObj[type]) {
        state = update(state, {
          coachMarksObj: { [type]: { $set: {} } },
        });
      }
      Object.keys(params).map((key, index) => {
        state = update(state, {
          coachMarksObj: { [type]: { [key]: { $set: params[key] } } },
        });
      });
    }
    return state;
  },
  [UPDATE_COACHMARK_STATUS]: (state, action) => {
    const params = action.payload;
    state = update(state, {
      coachMarksViewStatus: { bookmarkStatus: { $set: true } },
    });
    return state;
  },
};

// Reducer
export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

// Auto-generated exports
export { initialState, REDUCER_HANDLERS };
